module.exports = __webpack_public_path__ + "img/noimage.5a6d7b6f.png";